import * as React from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { searchParamToObject } from "../../../helpers/SearchParamHelper";
import {
  CategoryInterface,
  FilterValueInterface,
} from "../../../interfaces/CategoryInterface";
import ContentDisplayComponent from "../../content/ContentDisplayComponent";

interface State {
  category: CategoryInterface | undefined;
}

const FilterValueContentComponent = React.memo(
  React.forwardRef(({ category }: State, ref) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const getFilterValuesIds = React.useCallback(
      (
        filterValues: FilterValueInterface[],
        ids: number[],
        r: FilterValueInterface[]
      ) => {
        for (const filterValue of filterValues) {
          if (ids.includes(filterValue.id)) {
            r.push(filterValue);
            if (filterValue.children) {
              getFilterValuesIds(filterValue.children, ids, r);
            }
          }
        }
      },
      []
    );

    const getSelectedFilterValues = React.useCallback(() => {
      if (!category?.filterCategories) {
        return [];
      }
      let ids: number[] = [];
      const searchParamsObject = searchParamToObject(searchParams);
      if (searchParamsObject.hasOwnProperty("filterValues[]")) {
        for (const fv of searchParamsObject["filterValues[]"]) {
          ids = [...ids, ...JSON.parse(fv).values];
        }
      }
      const r: FilterValueInterface[] = [];
      for (const filterCategory of category.filterCategories) {
        getFilterValuesIds(filterCategory.filter.filterValues, ids, r);
      }
      return r.filter((x) => x.content);
    }, [category?.filterCategories, searchParams, getFilterValuesIds]);
    const [selectedFilterValues, setSelectedFilterValues] = React.useState<
      FilterValueInterface[]
    >(getSelectedFilterValues());

    useEffect(() => {
      setSelectedFilterValues(getSelectedFilterValues());
    }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        {selectedFilterValues.map((fv) => (
          <ContentDisplayComponent key={fv.id} content={fv.content} />
        ))}
      </>
    );
  })
);

export default FilterValueContentComponent;
